import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
export function UrgencyBar() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 0,
    minutes: 30,
    seconds: 0
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) {
          return {
            ...prev,
            seconds: prev.seconds - 1
          };
        } else if (prev.minutes > 0) {
          return {
            ...prev,
            minutes: prev.minutes - 1,
            seconds: 59
          };
        } else if (prev.hours > 0) {
          return {
            ...prev,
            hours: prev.hours - 1,
            minutes: 59,
            seconds: 59
          };
        }
        return prev; // Timer finished
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatTime = (val: number) => val.toString().padStart(2, '0');
  return <motion.div initial={{
    y: -50,
    opacity: 0
  }} animate={{
    y: 0,
    opacity: 1
  }} transition={{
    duration: 0.5,
    delay: 0.5
  }} className="fixed top-0 left-0 w-full z-50 bg-black border-b border-yellow-500 py-2 px-4 shadow-[0_0_15px_rgba(234,179,8,0.3)]" data-id="element-48">
      <div className="max-w-7xl mx-auto flex flex-col sm:flex-row justify-between items-center text-xs sm:text-sm font-bold text-white gap-2" data-id="element-49">
        <div className="flex items-center gap-2" data-id="element-50">
          <span className="relative flex h-3 w-3" data-id="element-51">
            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-500 opacity-75" data-id="element-52"></span>
            <span className="relative inline-flex rounded-full h-3 w-3 bg-red-600" data-id="element-53"></span>
          </span>
          <span className="uppercase tracking-wide" data-id="element-54">
            OFERTA LIMITADA: Solo quedan 47 copias disponibles
          </span>
        </div>

        <div className="flex items-center gap-2 text-yellow-500 font-mono" data-id="element-55">
          <span data-id="element-56">LA OFERTA TERMINA EN:</span>
          <span className="bg-zinc-900 px-2 py-0.5 rounded border border-yellow-500/30" data-id="element-57">
            {formatTime(timeLeft.hours)}:{formatTime(timeLeft.minutes)}:
            {formatTime(timeLeft.seconds)}
          </span>
        </div>
      </div>
    </motion.div>;
}